import {Component, OnDestroy, OnInit} from '@angular/core';
import {DcpOrder} from '@app/model/order/dcp-order.model';
import {EntryGroupService} from '@app/product/services/entry-group.service';
import {OrderConfirmationPageService} from '@app/services/order/order-confirmation-page.service';
import {DcpEntryGroup, JsonService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {OrderFacade} from '@spartacus/order/root';
import {CmsComponentData} from '@spartacus/storefront';
import {isEmpty} from 'lodash-es';
import {Observable, ReplaySubject, Subscription} from 'rxjs';
import {filter, tap} from 'rxjs/operators';
import {OrderItemService} from '../../order-item/services/order-item.service';
import {
  CmsFlexComponentData,
  OrderConfirmationListItemComponentTexts,
  ParsedCmsFlexComponentData
} from './order-confirmation-order-item.model';

@UntilDestroy()
@Component({
  selector: 'dcp-order-confirmation-list-item',
  templateUrl: './order-confirmation-list-item.component.html',
  styleUrls: ['./order-confirmation-list-item.component.scss']
})
export class OrderConfirmationListItemComponent implements OnInit, OnDestroy {

  public orderEntries$: Observable<OrderEntry[]>;
  public cartEntryGroups$: Observable<DcpEntryGroup[]>;
  componentData$: Observable<CmsFlexComponentData>;
  componentTexts: OrderConfirmationListItemComponentTexts;

  componentDataSubscription: Subscription = Subscription.EMPTY;

  savedOrderEntries$ = new ReplaySubject<OrderEntry[]>(1);
  savedEntryGroups$ = new ReplaySubject<DcpEntryGroup[]>(1);
  savedOrder$ = new ReplaySubject<DcpOrder>(1);

  constructor(
    private cmsData: CmsComponentData<CmsFlexComponentData>,
    private jsonService: JsonService,
    public entryGroupService: EntryGroupService,
    private orderItemService: OrderItemService,
    private orderConfirmationService: OrderConfirmationPageService,
    public orderFacade: OrderFacade
  ) {
  }

  ngOnInit(): void {
    this.subscribeToComponentData();
    this.subscribeToOrder();
  }

  subscribeToOrder() {
    this.savedOrderEntries$.next(undefined);
    this.orderEntries$ = this.savedOrderEntries$.asObservable();
    const savedOrderEntries = this.orderConfirmationService.getOrderEntries();
    if (savedOrderEntries) {
      this.savedOrderEntries$.next(savedOrderEntries);
    }

    this.savedEntryGroups$.next(undefined);
    this.cartEntryGroups$ = this.savedEntryGroups$.asObservable();
    const savedCartEntryGroups = this.orderConfirmationService.getCartEntryGroups();
    if (savedCartEntryGroups) {
      this.savedEntryGroups$.next(savedCartEntryGroups);
    }

    this.orderFacade.getOrderDetails().pipe(
      filter(order => !isEmpty(order)),
      tap((order: DcpOrder) => {
        this.orderConfirmationService.saveOrderDetails(order);
        this.savedOrder$.next(order);
        this.savedOrderEntries$.next(order?.entries);

        this.orderConfirmationService.saveCartEntryGroups(order.entryGroups);
        this.savedEntryGroups$.next(order.entryGroups);
      }),
      untilDestroyed(this),
    ).subscribe();
  }

  /**
   * Fetches component data from cloud commerce.
   */
  subscribeToComponentData(): void {
    this.componentData$ = this.cmsData.data$;
    this.componentDataSubscription = this.componentData$.pipe(
      untilDestroyed(this)
    ).subscribe(d => {
      const componentData: ParsedCmsFlexComponentData =
        this.jsonService.parseSafely(d?.classificationsProductData) as ParsedCmsFlexComponentData;
      this.componentTexts = componentData.texts;
    });
  }

  ngOnDestroy(): void {
    this.orderItemService.clearOrderItemCollapsedState();
  }
}
